import { setUnlessDefined } from 'spiceutils';

export default function getListOfCountrySpecificBreaks(breakControlList) {
  /*
   * Country-specific breaks are stored in the format:
   * [
   *   {[BREAK_NAME]: COUNTRY},
   *   {[BREAK_NAME]: COUNTRY}
   * ]
   *
   * Returns following structure:
   * {
   *   [BREAK_NAME]: [list of countries],
   *   [OTHER_BREAK]: [list of countries],
   * }
   */
  const countrySpecificBreaks = {};
  breakControlList.Options.CountrySpecific.forEach((bk) => {
    const breakName = Object.keys(bk)[0];
    setUnlessDefined(countrySpecificBreaks, breakName, []);
    countrySpecificBreaks[breakName].push(Object.values(bk)[0]);
    return undefined; // We don't care about returning here, we just want to loop
  });

  return countrySpecificBreaks;
}



// WEBPACK FOOTER //
// ./app/utils/AYDAUtils/getListOfCountrySpecificBreaks.js